export const getClientLocation = async () => {
  try {
    let data = await fetch(
      'https://api.geoapify.com/v1/ipinfo?&apiKey=5c65593b7d244d6a870db462a612c337',
    ).then(response => response.json());
    return data;
  } catch (e) {
    //Fallback to default location
    return [0, 0];
  }
};
